import * as React from "react";
import { Item } from "@/types/fse";
import { DriveRowNameFolder } from "@/views/drive/components/driverRowName/driveRowNameFolder";
import { DriveRowNameDocumentGroup } from "@/views/drive/components/driverRowName/driveRowNameDocumentGroup";
import { DriveRowNameFile } from "@/views/drive/components/driverRowName/driveRowNameFile";

interface Props {
  item: Item;
  isDragging: boolean;
}

export const DriveRowName: React.FC<Props> = ({ item, isDragging }) => {
  const isShared = item.access === "public" || item.permissions.length > 1;

  if (item.type === "folder") {
    return <DriveRowNameFolder item={item} isShared={isShared} />;
  }
  if (item.type === "file" && item.document_group_id) {
    return <DriveRowNameDocumentGroup item={item} isShared={isShared} />;
  }

  return <DriveRowNameFile item={item} isShared={isShared} isDragging={isDragging} />;
};
